import api from './index';
import getCookie from '../utils/getCookie';

function setParams(params, name) {
  const arrCookies = getCookie(name);

  if (arrCookies) {
    params[name] = JSON.parse(arrCookies); // eslint-disable-line no-param-reassign
  }

  return params;
}

export default {
  getUser() {
    const params = {};

    setParams(params, 'cathid');

    return api.get('/personal/user', { params });
  },
};
